let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');
let tabClass = '.package--tabbed-content';
let tabIndex = 1;

class TabbedContent {

  constructor($tabs) {
    this.$tabs = $($tabs);
    this.$prevBtn = this.$tabs.find('.tab-prev');
    this.$nextBtn = this.$tabs.find('.tab-next');

    this.$prevBtn.off('click touch').on('click touch', () => this.activeTab(tabIndex += -1, this.$tabs));
    this.$nextBtn.off('click touch').on('click touch', () => this.activeTab(tabIndex += 1, this.$tabs));
  }

  activeTab(n, $testimonies) {
    var i;
    var tabsTitle = $('.tabs-title', $testimonies);
    var tabsContent = $('.tabs-panel', $testimonies);

    if (n > tabsTitle.length) {
      tabIndex = 1;
    }
    if (n < 1) {
      tabIndex = tabsTitle.length;
    }

    for (i = 0; i < tabsTitle.length; i++) {
      $(tabsTitle[i]).removeClass('is-active');
      $(tabsContent[i]).removeClass('is-active');
    }

    var contentId = $(tabsTitle[tabIndex-1]).find('a.tab-anchor').attr('href');

    $(tabsTitle[tabIndex-1]).addClass('is-active');
    $($testimonies).find(contentId).addClass('is-active');
  }
}

/**
 * Initialize active tab function
 */
function init() {

  if($(tabClass).length) {

    $.each($(tabClass), (index, elem) => {
      let tabbedContent = new TabbedContent(elem);
    });
  }
}

if(typeof Drupal === 'undefined') {

  // Initialize for Styleguide
  $(document).ready(() => {
    init();
  });

}
else {
  module.exports = {
    attach: function(context, settings) {
      init();
    }
  };
}
